import { defineMessages } from 'react-intl';
export default defineMessages({
  logout: {
    id: 'common.nav.logout',
    defaultMessage: 'Logout'
  }
});